import Button from "@/components/Button";
import { useTranslation } from "@repo/shared/i18n";
import { useNavigate } from "react-router";

export const StillStrugglingSection = () => {
  const { t } = useTranslation("clubImport");
  const navigate = useNavigate();
  return (
    <section className="mb-12 p-12 bg-panel-background rounded-3xl">
      <h2 className="text-white text-2xl font-semibold mb-4">
        {t("tutorial.stillStruggling.title")}
      </h2>
      <p className="text-dark-tertiary text-sm mb-8 max-w-3xl">
        {t("tutorial.stillStruggling.intro")}
      </p>

      {/* Solution Cards Container - flex-wrap */}
      <div className="flex flex-wrap gap-6">
        {/* Troubleshooting Card */}
        <div className="w-[480px] flex-shrink-0">
          {/* Image placeholder */}
          <img
            className="w-[480px] h-[289px] bg-new-gray-800 rounded-[20px] mb-4 flex items-center justify-center border border-new-gray-700"
            src={`${import.meta.env.VITE_APP_ASSETS_BASE_URL}/import-tutorial/desktop/trouble-shooting-page.png`}
          />
          <h3 className="text-white font-semibold mb-2">
            {t("tutorial.stillStruggling.troubleshooting.title")}
          </h3>
          <p className="text-dark-secondary text-sm mb-4">
            {t("tutorial.stillStruggling.troubleshooting.body")}
          </p>
          <Button
            variant="primary"
            label={t("tutorial.stillStruggling.troubleshooting.cta")}
            onClick={() => navigate("/import-troubleshoot")}
          />
        </div>

        {/* Discord Card */}
        <div className="w-[480px] flex-shrink-0">
          {/* Image placeholder */}
          <img
            className="w-[480px] h-[289px] bg-new-gray-800 rounded-[20px] mb-4 flex items-center justify-center border border-new-gray-700"
            src={`${import.meta.env.VITE_APP_ASSETS_BASE_URL}/import-tutorial/desktop/discord.png`}
          />
          <h3 className="text-white font-semibold mb-2">
            {t("tutorial.stillStruggling.discord.title")}
          </h3>
          <p className="text-dark-secondary text-sm mb-4">
            {t("tutorial.stillStruggling.discord.body")}
          </p>
          <Button
            variant="primary"
            label={t("tutorial.stillStruggling.discord.cta")}
            onClick={() => {
              window.open(
                "https://discord.gg/easysbc-980827940902293525",
                "_blank",
              );
            }}
          />
        </div>
      </div>
    </section>
  );
};
